export default function WordCefr({className, data, ...props}) {

    return (
        <div

            className={`w-24 h-24 flex flex-col  justify-center items-center rounded-full bg-secondary-900 text-white  ${className}`}>
            <h2 className={"font-bold text-base"}>
                Level
            </h2>
            <h1 className={"font-bold text-2xl"}>
                {
                    data?.level
                }
            </h1>
        </div>

    )
}